function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_11013_291279)"
}, React.createElement("path", {
  d: "M9.91675 1.08325L12.2501 3.41659L9.91675 5.74992",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M1.75 6.91675V5.75008C1.75 5.13124 1.99583 4.53775 2.43342 4.10017C2.871 3.66258 3.46449 3.41675 4.08333 3.41675H12.25",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M4.08333 13.9167L1.75 11.5833L4.08333 9.25",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M12.25 8.08325V9.24992C12.25 9.86876 12.0042 10.4622 11.5666 10.8998C11.129 11.3374 10.5355 11.5833 9.91667 11.5833H1.75",
  stroke: "#FAFAFA",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_11013_291279"
}, React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgReverseIconPortfolio = function SvgReverseIconPortfolio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReverseIconPortfolio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReverseIconPortfolio.958a3f67.svg";
export { ForwardRef as ReactComponent };